import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function SiteFooter() {
  const { t } = useTranslation();
  const year = new Date().getFullYear();

  return (
    <footer className="mt-16 border-t border-gray-200/60 bg-white/50 backdrop-blur-sm">
      <div className="container mx-auto px-6 py-8 text-sm text-gray-500">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <div className="font-medium opacity-80">
            © {year} Jolkia. All rights reserved.
          </div>
          <div className="flex flex-wrap gap-x-6 gap-y-2">
            <Link to="/terms" className="hover:text-indigo-600 transition-colors">
              {t('legal.pages.cgu')}
            </Link>
            <Link to="/terms/sales" className="hover:text-indigo-600 transition-colors">
              {t('legal.pages.cgv')}
            </Link>
            <Link to="/privacy" className="hover:text-indigo-600 transition-colors">
              {t('legal.pages.privacy')}
            </Link>
            <Link to="/ai-data-usage" className="hover:text-indigo-600 transition-colors">
              {t('legal.pages.ai_data_usage')}
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}


